import React from 'react';
import { useState, useEffect } from "react";
/**
 * Bulk Discount table
 *
 * @returns {Object}
 */
export default function BulkDiscountTable() {
  const [content, setContent] = useState('');
  useEffect(() => {
    window.addEventListener("load", () => {
      // Execute the effect only after the page has loaded
      const element = document.getElementById("pricing-discount");

      if (element) {
        const originalElement = element.querySelector(
          ".aiod-volume-discount-wrap"
        );

        if (originalElement) {
          const clonedElement = originalElement.cloneNode(true);
          clonedElement.style.display = "block";
     
          setContent(clonedElement.innerHTML);
        }
      }
    });
  }, []);
  return <div dangerouslySetInnerHTML={{ __html: content }} />;
}
